import type { Shape, ShapeKind } from '../../../shared/types.ts';

/** Adds the outline of a shape of size w×h (local coords) to the current path. */
export function traceShape(ctx: CanvasRenderingContext2D, kind: ShapeKind, w: number, h: number): void {
  switch (kind) {
    case 'rect':
      ctx.rect(0, 0, w, h);
      break;
    case 'ellipse':
      ctx.ellipse(w / 2, h / 2, w / 2, h / 2, 0, 0, Math.PI * 2);
      break;
    case 'diamond':
      ctx.moveTo(w / 2, 0);
      ctx.lineTo(w, h / 2);
      ctx.lineTo(w / 2, h);
      ctx.lineTo(0, h / 2);
      ctx.closePath();
      break;
    case 'triangle':
      ctx.moveTo(w / 2, 0);
      ctx.lineTo(w, h);
      ctx.lineTo(0, h);
      ctx.closePath();
      break;
  }
}

export function drawShape(ctx: CanvasRenderingContext2D, o: Shape, lod: boolean): void {
  ctx.beginPath();
  traceShape(ctx, o.kind, o.w, o.h);
  const filled = o.fill !== 'transparent';
  if (filled) {
    ctx.fillStyle = o.fill;
    ctx.fill();
  }
  // At low zoom strokes are sub-pixel noise; keep them only if there's no fill.
  if (o.strokeWidth > 0 && o.stroke !== 'transparent' && (!lod || !filled)) {
    ctx.lineWidth = o.strokeWidth;
    ctx.strokeStyle = o.stroke;
    ctx.lineJoin = 'round';
    ctx.stroke();
  }
}
